import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import Link from "../../../Link";

const ExploreMenu = ({ isActive }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      ...ExploreMenuIcons
    }
  `);

  return (
    <div
      id="sub-menu__explore"
      className={cx(
        "container sub-menu sub-menu__explore row ",
        { active: isActive },
        { inactive: !isActive }
      )}
    >
      <div className="col-6 mx-1 mx-xl-3 mt-5">
        <Link className="d-block" to={`/explore/zipworld/`}>
          <div className="d-flex mb-2">
            <img
              className="mr-2"
              src={data.zipworldIcon.publicURL}
              alt={""}
              loading="lazy"
              width={24}
              height={24}
            />
            <h5>{t("menu.explore.content.title")}</h5>
          </div>
          <span
            dangerouslySetInnerHTML={{
              __html: t("menu.explore.content.description"),
            }}
          />
          <p className="content-link mt-4">
            {t("zipworld.btnExploreZipworld")} &#8594;
          </p>
        </Link>
      </div>
      <div className="col mx-1 mx-xl-3 align-self-end">
        <StaticImage
          className="d-block"
          src={"../../../../assets/images/menus/explore.png"}
          alt=""
        />
      </div>
    </div>
  );
};

export default ExploreMenu;
